import { Controller, useForm } from 'react-hook-form';
import { useResetPasswordMutation } from '../../store/authApi';
import Button from '../Button/Button';
import Input from '../Input/Input';
import style from '../modals/Recovery/Recovery.module.scss';
import ClipLoader from 'react-spinners/ClipLoader';
import '../../scss/style.scss';
import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import UseGeneralHooks from '../../hooks/useGeneralHooks';

const ResetPasswordForm = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm();

  const { token } = useParams();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');

  const [resetPasswordReq, { isSuccess, isLoading }] =
    useResetPasswordMutation();

  const onSubmit = (data) => {
    if (data?.password === data?.password_confirmation) {
      const payload = {
        email: email,
        password: data?.password,
        password_confirmation: data?.password_confirmation,
        token: token,
      };
      resetPasswordReq(payload);
    } else {
      setError('password', { message: 'Passwords are not the same' });
    }
  };

  const { navigate } = UseGeneralHooks();

  useEffect(() => {
    if (isSuccess) {
      navigate('/');
    }
  }, [isSuccess]);

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={style['reset-password__form']}
    >
      <Controller
        control={control}
        name='password'
        rules={{
          required: 'Required',
        }}
        render={({ field: { onChange, name, value } }) => {
          return (
            <Input
              value={value}
              onChange={onChange}
              icon={
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M11.3333 5.99996C11.3333 5.65874 11.2031 5.31753 10.9428 5.05719C10.6825 4.79684 10.3412 4.66667 10 4.66667M10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 6.18245 6.01222 6.36205 6.03587 6.53802C6.07478 6.82745 6.09424 6.97217 6.08114 7.06373C6.0675 7.1591 6.05013 7.2105 6.00313 7.2946C5.958 7.37533 5.87847 7.45486 5.71942 7.61391L2.31242 11.0209C2.19712 11.1362 2.13947 11.1939 2.09824 11.2611C2.06169 11.3208 2.03475 11.3858 2.01842 11.4538C2 11.5306 2 11.6121 2 11.7752V12.9333C2 13.3067 2 13.4934 2.07266 13.636C2.13658 13.7614 2.23856 13.8634 2.36401 13.9273C2.50661 14 2.6933 14 3.06667 14H4.66667V12.6667H6V11.3333H7.33333L8.38609 10.2806C8.54514 10.1215 8.62467 10.042 8.7054 9.99687C8.7895 9.94987 8.8409 9.9325 8.93627 9.91886C9.02783 9.90576 9.17255 9.92522 9.46198 9.96413C9.63795 9.98778 9.81755 10 10 10Z'
                    stroke='white'
                    stroke-opacity='0.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </svg>
              }
              placeholder={'Password'}
              className={style.input}
              big
              border
              password
            />
          );
        }}
      />
      <Controller
        control={control}
        name='password_confirmation'
        rules={{
          required: 'Required',
        }}
        render={({ field: { onChange, name, value } }) => {
          return (
            <Input
              value={value}
              onChange={onChange}
              icon={
                <svg
                  width='16'
                  height='16'
                  viewBox='0 0 16 16'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M11.3333 5.99996C11.3333 5.65874 11.2031 5.31753 10.9428 5.05719C10.6825 4.79684 10.3412 4.66667 10 4.66667M10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2C7.79086 2 6 3.79086 6 6C6 6.18245 6.01222 6.36205 6.03587 6.53802C6.07478 6.82745 6.09424 6.97217 6.08114 7.06373C6.0675 7.1591 6.05013 7.2105 6.00313 7.2946C5.958 7.37533 5.87847 7.45486 5.71942 7.61391L2.31242 11.0209C2.19712 11.1362 2.13947 11.1939 2.09824 11.2611C2.06169 11.3208 2.03475 11.3858 2.01842 11.4538C2 11.5306 2 11.6121 2 11.7752V12.9333C2 13.3067 2 13.4934 2.07266 13.636C2.13658 13.7614 2.23856 13.8634 2.36401 13.9273C2.50661 14 2.6933 14 3.06667 14H4.66667V12.6667H6V11.3333H7.33333L8.38609 10.2806C8.54514 10.1215 8.62467 10.042 8.7054 9.99687C8.7895 9.94987 8.8409 9.9325 8.93627 9.91886C9.02783 9.90576 9.17255 9.92522 9.46198 9.96413C9.63795 9.98778 9.81755 10 10 10Z'
                    stroke='white'
                    stroke-opacity='0.5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </svg>
              }
              placeholder={'Confirm Password'}
              className={style.input}
              big
              border
              password
            />
          );
        }}
      />
      {errors?.password && (
        <label className='error-message'>{errors?.password?.message}</label>
      )}
      <Button className={style.button__spaceBig} filled>
        {isLoading ? (
          <ClipLoader color={'black'} size={15} />
        ) : (
          'Reset Password'
        )}
      </Button>
    </form>
  );
};

export default ResetPasswordForm;
